// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__Tk96D","icon":"BackButton_icon__yxsBN"};